
import { controls } from "../../controls";


const cashcreditrenewal = {
  label: "Cash Credit Renewal",
  pageLabel: "Cash Credit Renewal",
  starting: true,
  url: "cashcreditrenewal",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({ label: "Min Advance", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Min Advance", name: "min_advance", width: "col-sm-4" }),
    ...controls.displayText({ label: "Min Advance Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-4", name: "min_advance_date" }),
    ...controls.displayText({ label: "Max Advance", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Man Advance", name: "man_advance", width: "col-sm-4" }),
    ...controls.displayText({ label: "Max Advance Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-4", name: "man_advance_date" }),
    ...controls.displayText({ label: "Avg Balance", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Avg Balance", name: "avg_balance", width: "col-sm-4" }),
    ...controls.displayText({ label: "Receipts", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Receipts", name: "receipts", width: "col-sm-4" }),
    ...controls.displayText({ label: "Interest Debited", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Interest Debited", name: "interest_debited", width: "col-sm-4" }),
    ...controls.displayText({ label: "Payments", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Payments", name: "payments", width: "col-sm-4" }),
    {
      widths: "col-sm-12",
    subComponents: [

    ...controls.displayText({ label: "Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "date" }),
    ...controls.displayText({ label: "Sanction Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "sanction_date" }),
    ...controls.displayText({ label: "Open Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "open_date" }),
    ...controls.displayText({ label: "Saction Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Saction Amount", name: "saction_amount", width: "col-sm-2" }),
    ...controls.displayText({ label: "Period", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Period", name: "period", width: "col-sm-2" }),
    ...controls.displayText({ label: "Maturity Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "maturity_date" }),
    ...controls.button({
      label: "ADD", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'cashcreditrenewal_table',
        requiredField: ["date", "sanction_date", "open_date", "sanction_amount", "period", "maturity_date"]
      },
      width: "col-sm-1",
      style: { padding: 0 },
      Bcolor: "success"
    }),
    {
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      // editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Date", field: "date",displaytype: 'date'},
        { label: "Saction Date", field: "sanction_date",displaytype: 'date'},
        { label: "Open Date", field: "open_date",displaytype: 'date'},
        { label: "Saction Amount", field: "sanction_amount",displaytype: 'currency' },
        { label: "Period", field: "period" },
        { label: "Maturity Date", field: "maturity_date" ,displaytype: 'date'},
        // { label: "Given Date", field: "given_date" }
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "cashcreditrenewal_table"
    },
    ]
  },

    
    
  ]
}

export default cashcreditrenewal;